import { useTranslation } from "react-i18next";
import { IoCChooser } from "../IoCChooser";
import { DropdownFilter } from "../../../../components/Filters/DropdownFilter";
import { useSearchContext } from "../../contexts";

interface IoCChooserDropdownProps {
  onOpenChange?: (isOpen: boolean) => void;
}

export const IoCChooserDropdown: React.FC<IoCChooserDropdownProps> = ({ onOpenChange }) => {
  const { state } = useSearchContext();
  const { t } = useTranslation();
  return (
    <DropdownFilter
      title={t("High risk accounts")}
      counter={state.draftFilters.discreditations.value.length}
      isExclude ={state.draftFilters.discreditations.exclude}
      onOpenChange={onOpenChange}
    >
      <IoCChooser />
    </DropdownFilter>
  )
};
